import clsx from 'clsx';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import closeIcon from 'images/directory/x_icon.svg';

import { TIModal } from '../../BaseUI';
import CustomUrlModalBody from '../CustomUrlModalBody';
import LeadCaptureModalBody from '../LeadCaptureModalBody';
import StandardOfferModalBody from '../StandardOfferModalBody';
import StandardSubscriptionModalBody from '../StandardSubscriptionModalBody';
import { MarketingModalProps } from '../index';
import styles from './styles.module.scss';

const STANDARD_OFFER_MODAL_TYPE = 'standard_offer';
const STANDARD_SUBSCRIPTION_MODAL_TYPE = 'standard_subscription';
const LEAD_CAPTURE_MODAL_TYPE = 'lead_capture';
const CUSTOM_URL_MODAL_TYPE = 'custom_url';

interface MarketingModalLayoutProps extends MarketingModalProps {
  closeModal: () => void;
  isOpen: boolean;
}

const MarketingModalLayout = ({
  closeModal,
  customUrl,
  buttonText,
  disclosure,
  guid,
  header,
  highlightedCta,
  isGdprLead,
  isOpen,
  modalType,
  offerLink,
  subtitle,
  title,
  trackingProps,
}: MarketingModalLayoutProps) => {
  return (
    <TIModal
      isOpen={isOpen}
      onClose={closeModal}
      parentClass={clsx(styles.marketingModal, {
        [styles.standardSizeModal]: [
          STANDARD_OFFER_MODAL_TYPE,
          LEAD_CAPTURE_MODAL_TYPE,
          CUSTOM_URL_MODAL_TYPE,
        ].includes(modalType),
        [styles.largeSizeModal]: modalType === STANDARD_SUBSCRIPTION_MODAL_TYPE,
      })}
      disableScrollLock={false}
      customHeader={true}
    >
      <div className={styles.header}>
        <div className={styles.headerText}>{header}</div>
        <div className={styles.closeIconWrapper}>
          <a className={styles.closeIcon} onClick={closeModal} data-test="close-modal">
            <img src={closeIcon} height="16" width="16" />
          </a>
        </div>
      </div>
      <div className={styles.marketingContent}>
        <div className={styles.contentWrapper}>
          <div className={styles.title}>{title}</div>
          <div className={styles.subtitle}>{ReactHtmlParser(subtitle)}</div>
          <div className={styles.highlightedCta}>{highlightedCta}</div>
          {/* Render correct type of modal based on modal type */}
          {modalType === LEAD_CAPTURE_MODAL_TYPE && (
            <LeadCaptureModalBody
              buttonText={buttonText}
              disclosure={disclosure}
              isGdprLead={isGdprLead}
              offerLink={offerLink}
              trackingProps={trackingProps}
              leadType="marketing_modal"
            />
          )}
          {modalType === STANDARD_OFFER_MODAL_TYPE && (
            <StandardOfferModalBody
              buttonText={buttonText}
              disclosure={disclosure}
              offerLink={offerLink}
              trackingProps={trackingProps}
            />
          )}
          {modalType === STANDARD_SUBSCRIPTION_MODAL_TYPE && (
            <StandardSubscriptionModalBody
              disclosure={disclosure}
              guid={guid}
              trackingProps={trackingProps}
            />
          )}
          {modalType === CUSTOM_URL_MODAL_TYPE && (
            <CustomUrlModalBody
              buttonText={buttonText}
              disclosure={disclosure}
              customUrl={customUrl}
              trackingProps={trackingProps}
            />
          )}
        </div>
      </div>
    </TIModal>
  );
};

export default MarketingModalLayout;
